import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { CoreMenuService } from '@core/components/core-menu/core-menu.service';
import { CoreConfigService } from '@core/services/config.service';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NftResolver implements Resolve<boolean> {
  constructor(private _coreMenuService: CoreMenuService, private _coreConfigService: CoreConfigService){}
  resolve(): Observable<boolean> {
    this._coreMenuService.setCurrentMenu('nft');
    this._coreConfigService.setConfig({
      layout: {
        type: 'vertical',
        skin: 'dark',
        navbar: {
          hidden: false,
          type: 'fixed-top',
          background: 'navbar-light',
        },
        menu: {
          hidden: false,
          collapsed: false
        },
        footer: {
          hidden: false
        },
        customizer: false,
        enableLocalStorage: true
      }
    }, { emitEvent: true });
    return of(true);
  }
}
